import axios, { AxiosInstance } from "axios";

const axiosInstance = (
  token?: string,
  isFullAxiosResponse = false,
  h?: Record<string, string>
): AxiosInstance => {
  const headers: Record<string, string> = {
    ...h,
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const instance = axios.create({
    timeout: 30 * 1000,
    headers,
  });

  instance.interceptors.response.use(
    (response) => {
      if (isFullAxiosResponse) return response;
      return response.data;
    },
    (error) => {
      return Promise.reject(error?.response);
    }
  );

  return instance;
};

export default axiosInstance;
